const initDeleteApplication = () => {
  const applications = document.querySelectorAll('[data-application]');

  if (!applications.length) {
    return;
  }

  document.addEventListener('click', (evt) => {
    const target = evt.target;

    if (!target.closest('[data-application-delete-button]')) {
      return;
    }

    const applicaton = target.closest('[data-application]');

    const params = {
      id: applicaton.dataset.application,
    };

    fetch('/local/templates/ballet/ajax/delete-application.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(params).toString(),
    })
        .then((response) => response.json())
        .then((response) => {
          if (response.success) {
            applicaton.remove();
          }
        });
  });
};

export {initDeleteApplication};
